import {
  Aktivitet,
  AktivitetState,
  EnkelinventeringAktivitet,
  Inventering,
  Migreringsaktivitet,
  Skyddsklassningsaktivitet
} from 'models';

// Hook som tar fram den aktuella aktiviteten då det är separerat på typ i slicen.
// Endast en av aktivitetstyperna kan ha data åt gången.
export const useGetCurrentAktivitet = (
  aktivitetData:
    | {
        eTag?: string;
        inventering?: Inventering;
        skyddsklassning?: Skyddsklassningsaktivitet;
        migrering?: Migreringsaktivitet;
        enkelinventering?: EnkelinventeringAktivitet;
      }
    | undefined
) => {
  if (aktivitetData) {
    return (Object.entries(aktivitetData) as [keyof AktivitetState, AktivitetState[keyof AktivitetState]][]).find(
      ([key, value]) => key !== ('eTag' as keyof AktivitetState) && value !== undefined
    )?.[1] as Aktivitet;
  }
};
